import React from "react";
import {Link} from 'react-router-dom'

import {
  chakra,
  Flex,
  useColorModeValue,
  HStack,
  Button,
} from "@chakra-ui/react";
import { AiFillHome, AiFillBank, AiOutlineHistory } from "react-icons/ai";

export default function NavBar() {
  const bg = useColorModeValue("white", "gray.800");

  function handleClick(e, { name }) {
    console.log(name);
  }

  return (
    <React.Fragment>
      <chakra.header
        bg={bg}
        w="full"
        px={{ base: 2, sm: 4 }}
        py={4}
        shadow="md"
      >
        <Flex alignItems="center" justifyContent="space-between" mx="auto">
          <HStack display="flex" spacing={3} alignItems="center">
            <HStack spacing={3} display={{ base: "none", md: "inline-flex" }}>
              <Button
                variant="ghost"
                leftIcon={<AiFillHome />}
                size="sm"
                name="home"
                onClick={handleClick}
                as={Link}
                to="/"

              >
                Home
              </Button>

              <Button
                variant="ghost"
                leftIcon={<AiFillBank />}
                size="sm"
                name="leon"
                onClick={handleClick}
                as={Link}
                to="/leon"
              >
                Leon
              </Button>
              <Button
                variant="ghost"
                leftIcon={<AiFillBank />}
                size="sm"
                name="tram"
                onClick={handleClick}
                as={Link}
                to="/tram"
              >
                Tram
              </Button>
              <Button
                variant="ghost"
                leftIcon={<AiOutlineHistory />}
                size="sm"
                name="history"
                onClick={handleClick}
                as={Link}
                to="/transactions"
              >
                History
              </Button>
            </HStack>
          </HStack>
        </Flex>
      </chakra.header>
    </React.Fragment>
  );
}
